import { render, staticRenderFns } from "./ProfileData.vue?vue&type=template&id=478e6fc4&scoped=true&"
import script from "./ProfileData.vue?vue&type=script&lang=js&"
export * from "./ProfileData.vue?vue&type=script&lang=js&"
import style0 from "./ProfileData.vue?vue&type=style&index=0&id=478e6fc4&scoped=true&lang=css&"
import style1 from "./ProfileData.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478e6fc4",
  null
  
)

export default component.exports